import { ProductPageService } from '@empathybroker/ebx-gluon';
import { injectable } from 'inversify';

@injectable()
export class CdlProductPageService implements ProductPageService {
  getResultId(): string {
    const pathParts = window.location.pathname.split('/');
    return pathParts[pathParts.length - 1];
  }
}
